var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 100,
    height: 80,
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D4E9DD;}\n\t.st1{fill:#6A987C;}\n\t.st2{fill:#6A987C;stroke:#6A987C;stroke-width:7.3091;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1_00000088091073147536014100000018301274964010872982_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lager_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2_00000020358103869014507270000009626004818616210363_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485,405.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Passport"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    className: "st1",
    d: "M121.1,157.2c0-28.9,23.3-52.3,52.1-52.3l0,0h333.1c28.8,0,52.1,23.5,52.1,52.3l0,0v464 c0,28.9-23.3,52.3-52.1,52.3l0,0H173.1c-28.8,0-52.1-23.5-52.1-52.3l0,0L121.1,157.2L121.1,157.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000024702828300036254660000017373833854957819322_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_00000068646263887659715630000000269008015891765428_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Passport_00000056403673894301942240000004259904702858647701_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base_00000046326370195132180720000016767365186401879993_",
    className: "st0",
    d: "M114.2,157c0-28.8,23.3-52.1,52.1-52.1l0,0 h333.1c28.8,0,52.1,23.3,52.1,52.1l0,0v461.5c0,28.8-23.3,52.1-52.1,52.1l0,0H166.3c-28.8,0-52.1-23.3-52.1-52.1l0,0V157z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M611,272.5h74.8v262.7l-25.6,72.7c-4.9,9.7-18.7,9.7-23.6,0l-25.6-72.7L611,272.5L611,272.5z M611,242.3v-48.1 c0-8.3,6.8-15.1,15.1-15.1h44.6c8.3,0,15.1,6.8,15.1,15.1v48.1H611z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M605.5,272.5h74.8v262.7l-25.6,72.7c-4.9,9.7-18.7,9.7-23.6,0l-25.6-72.7L605.5,272.5L605.5,272.5z  M605.5,242.3v-48.1c0-8.3,6.8-15.1,15.1-15.1h44.6c8.3,0,15.1,6.8,15.1,15.1v48.1H605.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M509.4,257.4H156.1c-2.7,0-4.8,2.1-4.8,4.8l0,0c0,2.7,2.1,4.8,4.8,4.8h353.2c2.7,0,4.8-2.1,4.8-4.8l0,0 C514.2,259.6,512,257.4,509.4,257.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M432.5,338.7H156.1c-2.7,0-4.8,2.1-4.8,4.8l0,0c0,2.7,2.1,4.8,4.8,4.8h276.4c2.7,0,4.8-2.1,4.8-4.8l0,0 C437.4,340.9,435.2,338.7,432.5,338.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M352.7,420H156.1c-2.7,0-4.8,2.1-4.8,4.8l0,0c0,2.7,2.1,4.8,4.8,4.8h196.6c2.7,0,4.8-2.1,4.8-4.8l0,0 C357.6,422.2,355.4,420,352.7,420z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.8,501.4H156.1c-2.7,0-4.8,2.1-4.8,4.8l0,0c0,2.7,2.1,4.8,4.8,4.8h100.6c2.7,0,4.8-2.1,4.8-4.8l0,0 C261.6,503.5,259.4,501.4,256.8,501.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputPen);
export default __webpack_public_path__ + "static/media/input-pen.fc09d44f5d73cac2d5ca849f1c3ae6f3.svg";
export { ForwardRef as ReactComponent };